<cerrix-loader [cerrixTab]="parentTab"></cerrix-loader>

<div class="detail-page-action-bar flex-action-bar">
    <div>
        <button data-uiid="button-save" class="btn btn-cerrix" (click)="saveSettings()">
            <i class="fas fa-save"></i>
            <span class="d-none d-lg-inline">{{ 'settings.saveButton' | t }}</span>
        </button>
    </div>
</div>

<div class="detail-page-card">
    <div class="detail-page-card-title">{{ 'settings.title' | t }}</div>
    <div class="detail-page-card-body padded">
        <cerrix-textfield
            name="slackToken"
            [fieldLabel]="'settings.slackTokenLabel' | t"
            dataUiid="notification-settings-slack-token"
            [(ngModel)]="slackToken"
        >
        </cerrix-textfield>
        <label class="help-text" [innerHTML]="'settings.slackTokenHelp' | t"></label>
    </div>
</div>

<div class="detail-page-card">
    <div class="detail-page-card-title">{{ 'settings.slackOptionsTitle' | t }}</div>
    <div class="detail-page-card-body padded">
        <div>
            <button data-uiid="button-sync" class="btn btn-success" (click)="syncAllUsers()">
                <i class="fas fa-sync"></i>
                <span class="d-none d-lg-inline">{{ 'settings.linkSlackAccountForAllUsers' | t }}</span>
            </button>
        </div>
    </div>
</div>
